import { EmailBlockType } from "@redotech/redo-model/email-builder";
import { NamedExoticComponent } from "react";
import { NestedEmailButton } from "./blocks/button";
import { NestedEmailImage } from "./blocks/image";
import { NestedEmailText } from "./blocks/text";

export const nestedEmailBlocks: Record<
  EmailBlockType,
  NamedExoticComponent<any> | undefined
> = {
  [EmailBlockType.TEXT]: NestedEmailText,
  [EmailBlockType.BUTTON]: NestedEmailButton,
  [EmailBlockType.TRACKABLE_SUMMARY]: undefined,
  [EmailBlockType.TRACKING_INFO]: undefined,
  [EmailBlockType.INTERACTIVE_CART]: undefined,
  [EmailBlockType.HEADER]: undefined,
  [EmailBlockType.FOOTER]: undefined,
  [EmailBlockType.IMAGE]: NestedEmailImage,
  [EmailBlockType.SPACER]: undefined,
  [EmailBlockType.LINE]: undefined,
  [EmailBlockType.REVIEW_REQUEST]: undefined,
  [EmailBlockType.COLUMN]: undefined,
  [EmailBlockType.MENU]: undefined,
  [EmailBlockType.SOCIALS]: undefined,
  [EmailBlockType.DISCOUNT]: undefined,
};
